import ClassNames from 'classnames';
import Image from 'next/image';
import { FC } from 'react';

import styles from './Button.module.scss';
interface IButton {
  value: string | number;
  className?: string;
  onClick?: () => void;
  href?: NonNullable<string>;
  target?: string;
  props?: any;
  icon?: string;
  type?: 'submit' | 'reset' | 'button';

  autoFocus?: boolean;
  disabled?: boolean;
  form?: string;
  formAction?: string;
  formEncType?: string;
  formMethod?: string;
  formNoValidate?: boolean;
  formTarget?: string;
  name?: string;
}

const Button: FC<IButton> = ({ value, className, onClick, href, icon, ...props }) => {
  return (
    <div className={ClassNames(styles.CustomButtom, className, icon && styles.addIcon)}>
      {href ? (
        <a href={href} onClick={onClick} {...props}>
          {value}
          {icon && (
            <div className={styles.icon}>
              <Image src={icon} alt={'button-icon'} layout={'fill'} />
            </div>
          )}
        </a>
      ) : (
        <button {...props} onClick={onClick}>
          {value}
          {icon && (
            <div className={styles.icon}>
              <Image src={icon} alt={'button-icon'} layout={'fill'} />
            </div>
          )}
        </button>
      )}
    </div>
  );
};

export default Button;
